googleBannerAdsBottom.$inject = ["$rootScope", "$timeout"];
angular.module('calendarApp').directive('googleBannerAdsBottom', googleBannerAdsBottom);

function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

function doAdsense(scope, $timeout) {
  try {
    scope.bannerCount = parseInt(Math.random() * 1000);

    if (smooth.env !== 'dev' && !smooth.subscribed) {
      $timeout(function () {
        try {
          (adsbygoogle = window.adsbygoogle || []).push({});
        } catch (err) {}
      }, 0);
    }
  } catch (e) {}
}

function doMonumetrics(scope, elem) {
  elem.ready(function () {
    console.log('initialising banner bottom');
    scope.bannerCount = parseInt(Math.random() * 1000);
    $MMT = window.$MMT || {};
    $MMT.cmd = $MMT.cmd || [];
    $MMT.cmd.push(function () {
      $MMT.display.slots.push(["818b8d1a-b4ce-42f9-a9b7-83145166bad9"]);
    });
  });
}

function googleBannerAdsBottom($rootScope, $timeout) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: smooth.calendar_url + '/partials/directives/advertisements/google-ads-bottom.html',
    scope: true,
    link: function link(scope, elem, attrs) {
      scope.devMode = smooth.env === 'dev';
      scope.showBanner = smooth.globalCharging && !smooth.subscribed;
      scope.adsType = smooth.adsprovider || 'ADSENSE';
      if (!$rootScope.cookieConsent) return;

      if (!scope.showBanner) {
        gtag('event', 'banner hidden', {
          event_category: 'banners',
          event_label: 'bottom'
        });
        return;
      }

      if (scope.adsType === 'MONUMETRICS') {
        doMonumetrics($rootScope, elem);
      } else {
        doAdsense(scope, $timeout);
      }

      if (inIframe()) {
        gtag('event', 'banner launched in iframe', {
          event_category: 'banners',
          event_label: 'bottom'
        });
      } else {
        gtag('event', 'banner impression', {
          event_category: 'banners',
          event_label: 'bottom'
        });
      }
    }
  };
}